/**
 * Created by efowler on 1/23/14.
 */
'use strict';

frontendApp.controller('AddReportModalCtrl', ['$scope', '$uibModalInstance', 'project', 'collections', 'search', 'filter', 'config', 'formConfig', 'ReportService', 'HttpService', 'ConfigService', 'NotificationService', 'PreferenceService', function($scope, $uibModalInstance, project, collections, search, filter, config, formConfig, ReportService, HttpService, ConfigService, NotificationService, PreferenceService) {

    $scope.project = project;

    $scope.saving = false;

    $scope.step = 1;
    $scope.maxSteps = 1;

    $scope.close = function() {
        if ($scope.saving) return;
        $uibModalInstance.close();
    };

    $scope.formConfig = {
        hideFields: false,
        hideDateFormat: false,
        hideMultiValueCharCode: false
    };
    angular.extend($scope.formConfig, formConfig);

    $scope.customizeFields = false;

    $scope.newReport = {
        projectId: project.id,
        type: "",
        format: "",
        name: "",
        multiValueCharCode: 59, // ;
        dateTimeFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSZ",
        hasHeaderRow: true,
        fields: [
            { type: "normal", name: "Id", outputName: "Id", isEnabled: true },
            { type: "normal", name: "ProjectId", outputName: "ProjectId", isEnabled: true },
            { type: "normal", name: "CollectionId", outputName: "CollectionId", isEnabled: true },
            { type: "normal", name: "SortKey", outputName: "SortKey", isEnabled: true },
            { type: "normal", name: "Custodian", outputName: "Custodian", isEnabled: true },

            // Filename
            { type: "normal", name: "RelativePath", outputName: "RelativePath", isEnabled: true },
            { type: "normal", name: "BaseName", outputName: "BaseName", isEnabled: true },
            { type: "normal", name: "Filename", outputName: "Filename", isEnabled: true },
            { type: "normal", name: "Extension", outputName: "Extension", isEnabled: true },
            { type: "normal", name: "AllPaths", outputName: "AllPaths", isEnabled: true },

            // What kind of file:
            { type: "normal", name: "Type", outputName: "Type", isEnabled: true },
            { type: "normal", name: "MimeType", outputName: "MimeType", isEnabled: true },
            { type: "normal", name: "Category", outputName: "Category", isEnabled: true },
            { type: "normal", name: "IsContainer", outputName: "IsContainer", isEnabled: true },
            { type: "normal", name: "IsRegularFile", outputName: "IsRegularFile", isEnabled: true },
            { type: "normal", name: "IsEmail", outputName: "IsEmail", isEnabled: true },
            { type: "normal", name: "IsSourceData", outputName: "IsSourceData", isEnabled: true },

            { type: "normal", name: "IsSystemFile", outputName: "IsSystemFile", isEnabled: true },
            { type: "normal", name: "IsDuplicateFile", outputName: "IsDuplicateFile", isEnabled: true },
            { type: "normal", name: "HasVirus", outputName: "HasVirus", isEnabled: true },
            { type: "normal", name: "WasPasswordProtected", outputName: "WasPasswordProtected", isEnabled: true },
            { type: "normal", name: "WasDecrypted", outputName: "WasDecrypted", isEnabled: true },
            { type: "normal", name: "Size", outputName: "Size", isEnabled: true },
            { type: "normal", name: "SystemTags", outputName: "SystemTags", isEnabled: true },
            { type: "normal", name: "ProjectTags", outputName: "ProjectTags", isEnabled: true },
            { type: "normal", name: "DomainTags", outputName: "DomainTags", isEnabled: true },
            { type: "normal", name: "BatchTags", outputName: "BatchTags", isEnabled: true },

            // Hash
            { type: "normal", name: "SHA1", outputName: "SHA1", isEnabled: true },
            { type: "normal", name: "SHA256", outputName: "SHA256", isEnabled: true },
            { type: "normal", name: "SHA512", outputName: "SHA512", isEnabled: true },
            { type: "normal", name: "MD5", outputName: "MD5", isEnabled: true },

            // Ancestry
            { type: "normal", name: "IsTopParentResource", outputName: "IsTopParentResource", isEnabled: true },
            { type: "normal", name: "TopParentResourceId", outputName: "TopParentResourceId", isEnabled: true },
            { type: "normal", name: "TopParentCreatedDate", outputName: "TopParentCreatedDate", isEnabled: true },
            { type: "normal", name: "ParentResourceId", outputName: "ParentResourceId", isEnabled: true },
            { type: "normal", name: "Ancestors", outputName: "Ancestors", isEnabled: true },

            { type: "normal", name: "EmbeddedIndex", outputName: "EmbeddedIndex", isEnabled: true },
            { type: "normal", name: "Language", outputName: "Language", isEnabled: true },

            { type: "normal", name: "HadProcessingException", outputName: "HadProcessingException", isEnabled: true },
            { type: "normal", name: "ProcessingException", outputName: "ProcessingException", isEnabled: true },

            // PDF Info
            { type: "normal", name: "NumPdfPages", outputName: "NumPdfPages", isEnabled: true },
            { type: "normal", name: "HadPdfException", outputName: "HadPdfException", isEnabled: true },
            { type: "normal", name: "PdfException", outputName: "PdfException", isEnabled: true },

            // Core Metadata
            { type: "normal", name: "CreatedDate", outputName: "CreatedDate", isEnabled: true },
            { type: "normal", name: "ModifiedDate", outputName: "ModifiedDate", isEnabled: true },
            { type: "normal", name: "PrintDate", outputName: "PrintDate", isEnabled: true },
            { type: "normal", name: "MetadataDate", outputName: "MetadataDate", isEnabled: true },

            { type: "normal", name: "Title", outputName: "Title", isEnabled: true },
            { type: "normal", name: "Creator", outputName: "Creator", isEnabled: true },

            { type: "normal", name: "EmailFrom", outputName: "EmailFrom", isEnabled: true },
            { type: "normal", name: "EmailTo", outputName: "EmailTo", isEnabled: true },
            { type: "normal", name: "EmailCc", outputName: "EmailCc", isEnabled: true },
            { type: "normal", name: "EmailBcc", outputName: "EmailBcc", isEnabled: true },
            { type: "normal", name: "EmailRecipients", outputName: "EmailRecipients", isEnabled: true },
            { type: "normal", name: "EmailMessageClass", outputName: "EmailMessageClass", isEnabled: true },
            { type: "normal", name: "EmailConversationTopic", outputName: "EmailConversationTopic", isEnabled: true },
            { type: "normal", name: "EmailDomains", outputName: "EmailDomains", isEnabled: true },
            { type: "normal", name: "InternetMessageId", outputName: "InternetMessageId", isEnabled: true },

            { type: "normal", name: "Notes", outputName: "Notes", isEnabled: true },
            { type: "normal", name: "PrivilegedNotes", outputName: "PrivilegedNotes", isEnabled: true },

            // Bates
            { type: "normal", name: "BegBates", outputName: "BegBates", isEnabled: true },
            { type: "normal", name: "EndBates", outputName: "EndBates", isEnabled: true },
            { type: "normal", name: "BegAttachBates", outputName: "BegAttachBates", isEnabled: true },
            { type: "normal", name: "EndAttachBates", outputName: "EndAttachBates", isEnabled: true },

            { type: "normal", name: "AllBegBates", outputName: "AllBegBates", isEnabled: true },
            { type: "normal", name: "AllEndBates", outputName: "AllEndBates", isEnabled: true },
            { type: "normal", name: "AllBegAttachBates", outputName: "AllBegAttachBates", isEnabled: true },
            { type: "normal", name: "AllEndAttachBates", outputName: "AllEndAttachBates", isEnabled: true },

            { type: "normal", name: "LocationEntities", outputName: "LocationEntities", isEnabled: true },
            { type: "normal", name: "PersonEntities", outputName: "PersonEntities", isEnabled: true },
            { type: "normal", name: "OrganizationEntities", outputName: "OrganizationEntities", isEnabled: true },
            { type: "normal", name: "MiscEntities", outputName: "MiscEntities", isEnabled: true },
            { type: "normal", name: "TimeEntities", outputName: "TimeEntities", isEnabled: true },
            { type: "normal", name: "DateEntities", outputName: "DateEntities", isEnabled: true },
            { type: "normal", name: "PercentEntities", outputName: "PercentEntities", isEnabled: true },
            { type: "normal", name: "MoneyEntities", outputName: "MoneyEntities", isEnabled: true },
            { type: "normal", name: "CommercialItemEntities", outputName: "CommercialItemEntities", isEnabled: true },
            { type: "normal", name: "EventEntities", outputName: "EventEntities", isEnabled: true },
            { type: "normal", name: "TitleEntities", outputName: "TitleEntities", isEnabled: true }
        ]
    };

    // Report specific data (must include format)
    angular.extend($scope.newReport, config);

    $scope.saveReport = function(report) {

        $scope.saving = true;
        var newReport = ReportService.Create({ projectId: project.id, type: report.type, format: report.format, name: report.name,  multiValueCharCode: report.multiValueCharCode, dateTimeFormat: report.dateTimeFormat, hasHeaderRow: report.hasHeaderRow, fields: report.fields });
        angular.extend(newReport, { collectionIds: collections ? collections : [], filter: filter, columnFilters: app.directives.controls.DataGrid.GetSearchExpressionFromFilterModel(PreferenceService.Get(app.model.user.Preferences.GRID_COLUMNS_FILTER_MODEL)) });



        if(search) {
            angular.extend(newReport, {
                isRawSearch: search instanceof app.model.search.AdvancedSearch,
                query: search instanceof app.model.search.BasicSearch ? search.expression : JSON.stringify(search.expression)
            });
        }

        ReportService.Save(newReport).then(function(report) {

            $scope.saving = false;
            $scope.close();

            NotificationService.addSuccess({
                title: 'Report started',
                description: 'Name: ' + report.name,
                timeout: 5000
            });

        }).catch(function(data) {
            $scope.saving = false;
        });

    };

    $scope.checkAllFields = function() {
        angular.forEach($scope.newReport.fields, function(field) {
            field.isEnabled = true;
        });
    };

    $scope.unCheckAllFields = function() {
        angular.forEach($scope.newReport.fields, function(field) {
            field.isEnabled = false;
        });
    };



}]);

